/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2023
 * @flow
 */

import React, { useState } from 'react';
import {
  Drawer,
  Toolbar,
  List,
  CssBaseline,
  Typography,
  ListItem,
  ListItemIcon,
} from '@material-ui/core';
import { menus } from '../../constants';
import Home from '../Home';
import Checks from '../Checks';
import Items from '../Items';
import Payment from '../Payment';
import useStyles from './useStyles';
import { version } from '../../../../../package.json';

export default function Body({
  commonData,
  items,
  paymentByTenderType,
  revenueCentersData,
  orderTypesData,
  hourlySales,
}) {
  const classes = useStyles();
  const [selectedMenu, setSelectedMenu] = useState('home');

  const onSelectMenu = menuType => {
    setSelectedMenu(menuType);
  };

  const getView = () => {
    switch (selectedMenu) {
      case 'home': return (
        <Home
          commonData={commonData}
        />
      );
      case 'checks': return (
        <Checks
          commonData={commonData}
          revenueCentersData={revenueCentersData}
          orderTypesData={orderTypesData}
          hourlySales={hourlySales}
        />
      );
      case 'items': return (
        <Items
          items={items}
          commonData={commonData}
          hourlySales={hourlySales}
        />
      );
      case 'payment': return (
        <Payment
          commonData={commonData}
          hourlySales={hourlySales}
          paymentByTenderType={paymentByTenderType}
        />
      );
      default: return null;
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" noWrap>OneDine</Typography>
        </Toolbar>
        <div className={classes.drawerContainer}>
          <List className={classes.list}>
            {menus.map(menu => (
              <ListItem
                button
                key={`key-${menu.key}`}
                selected={selectedMenu === menu.type}
                onClick={() => onSelectMenu(menu.type)}
                className={classes.selected}
              >
                <ListItemIcon><menu.icon /></ListItemIcon>
                <Typography className={classes.listItemText}>
                  {menu.label.toUpperCase()}
                </Typography>
              </ListItem>
            ))}
          </List>
        </div>
        <div className={classes.footer}>
          <Typography variant='caption' color='textSecondary'>Version: {version}</Typography>
        </div>
      </Drawer>
      <main className={classes.content}>
        {getView()}
      </main>
    </div>
  );
};
